<template>
  <or-icon-button
    class="create-knowledge-model"
    data-test="create-knowledge-model"
    color="primary"
    has-dropdown
    icon="add"
    ref="dropdownButton"
  >
    <or-menu
      ref="menu"
      slot="dropdown"
      contain-focus
      has-icons
      :options="menuOptions"
      @close="$refs.dropdownButton.closeDropdown()"
      @select="onSelect"
    />
  </or-icon-button>
</template>

<script>
import KnowledgeBus from '../../KnowledgeBus'
import findIndex from 'lodash/findIndex'
import trim from 'lodash/trim'

export default {
  mounted () {
    const childrens = this.$refs.menu.$el.children
    const index = findIndex(childrens, child => trim(child.innerText) === 'Create new model')
    childrens[index].setAttribute('data-test', 'create-new-knowledge-model')
  },

  data () {
    return {
      menuOptions: [
        {
          id: 'regular',
          label: 'Create new model'
        },
        {
          id: 'external',
          label: 'Create custom model'
        }
      ]
    }
  },

  methods: {
    onSelect (item) {
      if (item.id === 'regular') KnowledgeBus.$emit('create::open')
      if (item.id === 'external') KnowledgeBus.$emit('create-custom::open')
    }
  }
}
</script>

<style lang="scss" scoped>
.create-knowledge-model {
  display: flex;
  width: 56px;
  height: 56px;
  border-radius: 100%;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  color: white;
  background-color: $or-blue;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: darken($or-blue, 5%);
  }
}
</style>
